var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 45,
  height: 44,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  x: 0.5,
  fill: "#00A351",
  rx: 22
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#check_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m19 26.865-4.048-4.048a1.16 1.16 0 0 0-1.645 0 1.16 1.16 0 0 0 0 1.645l4.876 4.876c.455.455 1.19.455 1.645 0l12.344-12.343a1.16 1.16 0 0 0 0-1.645 1.16 1.16 0 0 0-1.645 0z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "check_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.5 8h28v28h-28z"
})))));
export { SvgCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NSIgaGVpZ2h0PSI0NCIgZmlsbD0ibm9uZSI+PHJlY3Qgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0IiB4PSIuNSIgZmlsbD0iIzAwQTM1MSIgcng9IjIyIi8+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJtMTkgMjYuODY1LTQuMDQ4LTQuMDQ4YTEuMTYgMS4xNiAwIDAgMC0xLjY0NSAwIDEuMTYgMS4xNiAwIDAgMCAwIDEuNjQ1bDQuODc2IDQuODc2Yy40NTUuNDU1IDEuMTkuNDU1IDEuNjQ1IDBsMTIuMzQ0LTEyLjM0M2ExLjE2IDEuMTYgMCAwIDAgMC0xLjY0NSAxLjE2IDEuMTYgMCAwIDAtMS42NDUgMHoiLz48L2c+PGRlZnM+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNOC41IDhoMjh2MjhoLTI4eiIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPg==";